// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"TP-z","categoryName":"UP-z","categoryNameSearchHeader":"VP-z","categoryContent":"WP-z","bottomAligned":"XP-z","image":"YP-z","imageNoBackground":"ZP-z"};